module.exports = __webpack_public_path__ + "img/empty-with-filters.5f8b5d70.gif";